import { type ComponentProps } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { configureReactQuillBlockTag } from '../../utils/configureReactQuillBlockTag';
import { normalizeQuillHtml } from '../../utils/normalizeQuillHtml';

const defaultModules = {
  toolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']],
};

const defaultFormats = ['bold', 'italic', 'underline', 'list', 'bullet', 'link'];

type ReactQuillProps = ComponentProps<typeof ReactQuill>;

export interface CoreQuillEditorProps
  extends Omit<ReactQuillProps, 'onChange' | 'modules' | 'formats'> {
  onChange: (value: string) => void;
  modules?: ReactQuillProps['modules'];
  formats?: ReactQuillProps['formats'];
}

configureReactQuillBlockTag();

const CoreQuillEditor = ({
  onChange,
  modules = defaultModules,
  formats = defaultFormats,
  ...props
}: CoreQuillEditorProps) => {
  const handleChange: NonNullable<ReactQuillProps['onChange']> = (content) => {
    onChange(normalizeQuillHtml(content));
  };

  return <ReactQuill {...props} onChange={handleChange} modules={modules} formats={formats} />;
};

export default CoreQuillEditor;
